
import { Row, Col, Nav } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { AiFillChrome, AiFillDashboard, AiFillSetting, AiOutlineKey, AiFillBell } from 'react-icons/ai'
import { BsUnlockFill, BsFillPiggyBankFill, BsEnvelopeFill } from 'react-icons/bs'
import {GiFishingSpoon} from 'react-icons/gi'
import { MdGroup } from 'react-icons/md'
import { FaComments } from 'react-icons/fa'
import { useSelector, useDispatch } from 'react-redux'
import { Steps, Hints } from "intro.js-react";
import API from '../api/api'
import Actions from '../redux/actions'
export default function SideBarNav(props) {


    const user = useSelector(state => state.user)
    const [show, setShow] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        setTimeout(() => {
            setShow(true)
        }, 1200)
    }, [])

    const _flipOnboard = async () => {
        const user = await API.flipOnboard()
        dispatch(Actions.setUser(user))
    }



    return (
        <div className="shadow vh-100 align-middle d-flex justify-content-between flex-column p-4 text-center bg-primary ">
            <div>


                <div className='text-center'>
                    <NavLink to='/'><img src={require('../assets/logo-circle.png')} alt='logo' className='img-fluid w-50 mx-auto mt-2 rounded-circle' /></NavLink>
                    <hr className='mx-2 text-white' />
                </div>

                {!user?.isOnBoarded && <Steps
                    enabled={show && !user?.isOnBoarded}
                    onExit={_flipOnboard}
                    onComplete={_flipOnboard}
                    steps={introSteps}
                    initialStep={0}
                />}

                <Nav defaultActiveKey="/" className='p-3 ps-1 flex-column'  >
                    <NavLink to='/' className={({ isActive }) => (`${isActive ? 'text-white weight-bold text-decoration-underline' : 'text-white'} m-2 noDecoration dashboard-link d-block me-auto`)}><AiFillDashboard className='me-2 my-auto align-middle my-auto' style={{ width: '1.2rem', height: '1.2rem' }} />Dashboard</NavLink>
                    <NavLink to='/user' className={({ isActive }) => (`${isActive ? 'text-white weight-bold text-decoration-underline' : 'text-white'} m-2 noDecoration users-link d-block me-auto`)}><MdGroup className='me-2 my-auto align-middle my-auto ' style={{ width: '1.2rem', height: '1.2rem' }} />Users</NavLink>
                    <NavLink to='/access' className={({ isActive }) => (`${isActive ? 'text-white weight-bold text-decoration-underline' : 'text-white'} m-2 noDecoration access-link d-block me-auto`)}><BsUnlockFill className='me-2 my-auto align-middle my-auto ' style={{ width: '1.2rem', height: '1.2rem' }} />Temp Access</NavLink>
                    <NavLink to='/email' className={({ isActive }) => (`${isActive ? 'text-white weight-bold text-decoration-underline' : 'text-white'} m-2 noDecoration access-link d-block me-auto`)}><BsEnvelopeFill className='me-2 my-auto align-middle my-auto ' style={{ width: '1.2rem', height: '1.2rem' }} />Blocked Emails</NavLink>
                    <NavLink to='/phishing' className={({ isActive }) => (`${isActive ? 'text-white weight-bold text-decoration-underline' : 'text-white'} m-2 noDecoration access-link d-block me-auto`)}><GiFishingSpoon className='me-2 my-auto align-middle my-auto ' style={{ width: '1.2rem', height: '1.2rem' }} />Phishing URLs</NavLink>
                    <NavLink to='/suggestion' className={({ isActive }) => (`${isActive ? 'text-white weight-bold text-decoration-underline' : 'text-white'} m-2 noDecoration suggestion-link d-block me-auto`)}><FaComments className='me-2 my-auto align-middle my-auto ' style={{ width: '1.2rem', height: '1.2rem' }} />Support</NavLink>
                    {user?.isAffiliate && <NavLink to='/affiliate' className={({ isActive }) => (`${isActive ? 'text-white weight-bold text-decoration-underline' : 'text-white'} m-2 noDecoration suggestion-link d-block me-auto`)}><BsFillPiggyBankFill className='me-2 my-auto align-middle my-auto ' style={{ width: '1.2rem', height: '1.2rem' }} />Affiliate Portal</NavLink>}

                    <NavLink to='/settings' className={({ isActive }) => (`${isActive ? 'text-white weight-bold text-decoration-underline' : 'text-white'} m-2 noDecoration d-block me-auto`)}><AiFillSetting className='me-2 my-auto align-middle my-auto' style={{ width: '1.2rem', height: '1.2rem' }} />Settings</NavLink>

                </Nav>
            </div>
            <div>
                <a id='addToChrome' className='btn bg-white text-primary mt-3' target='__blank' href='https://chrome.google.com/webstore/detail/scamwall/pjkegbkgamcijobfjmpbljhbolejfnip'><AiFillChrome /> Add to Chrome</a>
                <p className='text-white'><small>v0.1.0</small></p>
                <Row>
                    <Col>
                        <a target='__blank' className='text-white' href='https://scamwall.io/terms.html'>Terms</a>
                    </Col>
                    <Col>
                        <a target='__blank' className='text-white' href='https://scamwall.io/privacy.html'>Privacy</a>
                    </Col>
                </Row>
            </div>



        </div>
    )
}


const introSteps = [
    {
        element: '.dashboard-link',
        intro: 'See an overview of your account and sub users here.'
    },
    {
        element: '.users-link',
        intro: 'Bought ScamWall for a family member/friend? Create their account here.'
    },
    {
        element: '.access-link',
        intro: 'Do you or a user need legitimate access to a remote desktop program? Grant access here.'
    },

    {
        element: '.suggestion-link',
        intro: 'Have an idea to improve ScamWall? Leave it here.'
    },
]